import React from 'react';
import PropTypes from 'prop-types';
import { loginOktaToken, navigateToOktaBroker } from 'services/auth/duck';
import { isLoggedIn } from 'services/auth/selectors';
import { getDisplayName } from 'helpers/component';

export default function AdminAuthFlowEnhancer(options = {}) {
    const storeKey = options.store || 'store';
    delete options.store;

    return function AdminAuthFlowHOC(WrappedComponent) {
        class AdminAuthFlow extends React.Component {
            constructor(props, context) {
                super(props);
                this.store = context[storeKey];
            }

            componentDidMount() {
                if (options.oktaReceive) {
                    this.store.dispatch(loginOktaToken());
                } else if (!options.oktaReceive && !isLoggedIn(this.store.getState())) {
                    this.store.dispatch(navigateToOktaBroker());
                }
            }

            render() {
                // Wraps the input component in a container, without mutating it. Good!
                return <WrappedComponent {...this.props} />;
            }
        }

        AdminAuthFlow.contextTypes = {
            [storeKey]: PropTypes.object
        };

        AdminAuthFlow.displayName = `AdminAuthFlow(${getDisplayName(WrappedComponent)})`;

        return AdminAuthFlow;
    };
}



// WEBPACK FOOTER //
// ./src/hoc/AdminAuthFlow.js